// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function AirplaneBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M29.671 15.659 20.5 11.072V6a4.5 4.5 0 1 0-9 0v5.072L2.329 15.66A1.5 1.5 0 0 0 1.5 17v4a1.5 1.5 0 0 0 1.794 1.471L11.5 20.83v1.545l-1.561 1.564A1.501 1.501 0 0 0 9.5 25v4a1.5 1.5 0 0 0 2.057 1.392L16 28.615l4.442 1.777A1.5 1.5 0 0 0 22.5 29v-4a1.5 1.5 0 0 0-.439-1.061L20.5 22.375V20.83l8.206 1.641A1.501 1.501 0 0 0 30.5 21v-4a1.5 1.5 0 0 0-.829-1.341ZM27.5 19.17l-8.206-1.641A1.501 1.501 0 0 0 17.5 19v4a1.5 1.5 0 0 0 .439 1.061l1.561 1.564v1.164l-2.942-1.178a1.5 1.5 0 0 0-1.115 0L12.5 26.785v-1.16l1.561-1.56A1.5 1.5 0 0 0 14.5 23v-4a1.502 1.502 0 0 0-1.794-1.471L4.5 19.17v-1.243l9.171-4.586A1.5 1.5 0 0 0 14.5 12V6a1.5 1.5 0 1 1 3 0v6a1.5 1.5 0 0 0 .829 1.341l9.171 4.586v1.243Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
